
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const qs = (root, selector) => Array.from(root.querySelectorAll(selector));

  function initReveals(root = document) {
    const nodes = qs(root, '[data-bvp-reveal]:not([data-bvp-ready])');
    nodes.forEach((node) => node.dataset.bvpReady = 'true');
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -7% 0px' });
    nodes.forEach((node) => observer.observe(node));
  }

  let parallaxItems = [];
  let progressItems = [];
  let rafPending = false;

  function collectMotion() {
    parallaxItems = qs(document, '[data-bvp-parallax]');
    progressItems = qs(document, '[data-bvp-progress]');
    if (reduced) {
      parallaxItems.forEach((el) => el.style.setProperty('--bvp-parallax-y', '0px'));
      progressItems.forEach((el) => el.style.setProperty('--bvp-progress', '100%'));
      return;
    }
    updateMotion();
  }

  function updateMotion() {
    rafPending = false;
    const vh = window.innerHeight || 1;
    parallaxItems.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < -150 || rect.top > vh + 150) return;
      const strength = Number(el.dataset.bvpStrength || 28);
      const center = rect.top + rect.height / 2;
      const normalized = (center - vh / 2) / vh;
      const y = Math.max(-strength, Math.min(strength, -normalized * strength * 2));
      el.style.setProperty('--bvp-parallax-y', y.toFixed(2) + 'px');
    });
    progressItems.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const start = vh * 0.82;
      const end = vh * 0.2;
      const progress = Math.max(0, Math.min(1, (start - rect.top) / Math.max(1, rect.height + start - end)));
      el.style.setProperty('--bvp-progress', (progress * 100).toFixed(1) + '%');
    });
  }

  function onScroll() {
    if (reduced || rafPending) return;
    rafPending = true;
    requestAnimationFrame(updateMotion);
  }

  function initTilt(root = document) {
    if (reduced) return;
    qs(root, '[data-bvp-tilt]:not([data-bvp-tilt-ready])').forEach((el) => {
      el.dataset.bvpTiltReady = 'true';
      el.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        const rect = el.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        el.style.setProperty('--bvp-tilt-x', (-y * 4).toFixed(2) + 'deg');
        el.style.setProperty('--bvp-tilt-y', (x * 5).toFixed(2) + 'deg');
        el.style.setProperty('--bvp-shift-x', (x * 10).toFixed(2) + 'px');
        el.style.setProperty('--bvp-shift-y', (y * 10).toFixed(2) + 'px');
      });
      el.addEventListener('pointerleave', () => {
        el.style.setProperty('--bvp-tilt-x', '0deg');
        el.style.setProperty('--bvp-tilt-y', '0deg');
        el.style.setProperty('--bvp-shift-x', '0px');
        el.style.setProperty('--bvp-shift-y', '0px');
      });
    });
  }

  function init(root = document) {
    initReveals(root);
    initTilt(root);
    collectMotion();
  }

  document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();